export function isDynamicImportError(error: unknown) {
  if (!(error instanceof Error)) {
    return false;
  }

  const errorName = error.name.toLowerCase();
  const errorMessage = error.message.toLowerCase();

  return (
    errorName.includes('chunkloaderror') ||
    errorMessage.includes('failed to fetch dynamically imported module') ||
    errorMessage.includes('error loading dynamically imported module') ||
    errorMessage.includes('importing a module script failed')
  );
}
